import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-conversations }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/users/segments.hbs" })